export default interface IContact {
    id: number;
    propertyGroupIds: number[];
    name: string;
    positionFrench: string;
    positionEnglish: string;
    positionSpanish: string;
    email: string;
    phone: string;
}

export const DEFAULT_CONTACT: IContact = {
    id: 0,
    name: "",
    propertyGroupIds: [],
    positionFrench: "",
    positionEnglish: "",
    positionSpanish: "",
    email: "",
    phone: "",
};
